import React from 'react';

interface ButtonProps {
    text: string;
}

const BigTitle: React.FC<ButtonProps> = ({ text }) => {
    return (
        <h1 className="text-2xl font-extrabold">{text}</h1>
        
    );
};

export default BigTitle;